import styles from './../styles/section4.module.scss';
import React from 'react';
const Section4 = (props) => {
  return (
    <div id="ubicacion">
      <div className="py-4 px-md-5 px-2 mx-1 mx-md-5">
        <div className="d-flex justify-content-center justify-content-md-start">
          <div className="py-5 text-center text-md-left">
            <h1 className={styles.titleUbicacion + ' mt-4 text-center text-md-left'}>UBICACIÓN</h1>
            <div className={styles.line + ' px-4 mx-auto mx-md-0'}> </div>
          </div>
        </div>
        <p className={styles.textUbicacion + ' text-center text-md-left'}>
          Carretera libre a Celaya, KM 10 Corregidora, Querétaro, México.
        </p>
      </div>
      <div className="mx-auto w-75 py-5">
        <iframe
          className={styles.map}
          src="https://snazzymaps.com/embed/202959"
          width="100%"
          height="600px"
        ></iframe>
      </div>
    </div>
  );
};
export default Section4;
